const mediaFile = require('./media.js')

// Detect iOS browsers < version 10
const oldIOS = () => typeof navigator !== 'undefined' && parseFloat(
  ((/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent)
  || [ 0, '' ])[1])
    .replace('undefined', '3_2').replace('_', '.').replace('_', '')
) < 10 && !window.MSStream

/**
 * Class that will add a hidden video to the screen in order to prevent
 * the device from going into sleep-mode.
 */
export default class NoSleep {
  constructor() {
    if (oldIOS()) {
      this.noSleepTimer = null
    } else {
      // Set up no sleep video element
      this.noSleepVideo = document.createElement('video')

      this.noSleepVideo.setAttribute('playsinline', '')
      this.noSleepVideo.setAttribute('src', mediaFile)

      this.noSleepVideo.addEventListener('timeupdate', function () {
        if (this.noSleepVideo.currentTime > 0.5) {
          this.noSleepVideo.currentTime = Math.random()
        }
      }.bind(this))
    }
  }

  /**
   * Will prevent the device from entering sleep-mode.
   */
  enable() {
    if (oldIOS()) {
      this.disable()
      this.noSleepTimer = window.setInterval(function () {
        window.location.href = '/'
        window.setTimeout(window.stop, 0)
      }, 15000)
    } else {
      this.noSleepVideo.play()
    }
  }

  /**
   * Will make it so that the device can enter sleep-mode again
   */
  disable() {
    if (oldIOS()) {
      if (this.noSleepTimer) {
        window.clearInterval(this.noSleepTimer)
        this.noSleepTimer = null
      }
    } else {
      this.noSleepVideo.pause()
    }
  }
}
